module.exports = __webpack_public_path__ + "img/150.e49dfe52.jpg";